<template>
  <Component
    :is="'b-tooltip'"
    class="rs-tooltip"
    :triggers="triggers"
    :target="target"
    :title="title"
    :placement="position"
    :delay="delay"
    :variant="variant"
    :boundary="boundary"
  >
    <slot />
  </Component>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsTooltip',
  props: {
    target: {
      type: String,
      default: null,
      required: true,
    },
    variant: String,
    triggers: String,
    title: String,
    position: String,
    boundary: String,
    delay: {
      type: [Number, Object],
      default() {
        return { delay: 50 };
      },
    },
  },
});
</script>

<style lang="scss">
@import "@/styles/_variables.scss";
.b-tooltip{
  top: 0;
  opacity: 1 !important;
  &-secondary{
    .tooltip-inner{
      padding: 0.5rem 1rem;
      max-width: 400px;
      text-align: left;
      background-color: $secondary-color-dark !important;
    }
    .arrow:before{
      border-bottom-color: $secondary-color-dark !important;
    }
  }
  &-inline {
    .tooltip-inner {
      max-width: unset;
    }
  }
}
</style>
